var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.1,
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1c-4.968 0-9 4.032-9 9s4.032 9 9 9 9-4.032 9-9-4.032-9-9-9zm0 16.884A7.882 7.882 0 012.116 10 7.882 7.882 0 0110 2.116 7.882 7.882 0 0117.884 10 7.882 7.882 0 0110 17.884z",
    stroke: "#191C26",
    fill: "#191C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.781 9.604l1.656 1.656a2.084 2.084 0 01-.108 3.069 2.173 2.173 0 01-3.069 0h0l-1.656-1.656.846-.846 1.656 1.656c.423.423 1.062.423 1.377 0 .423-.423.423-1.062 0-1.377h0l-1.548-1.656.846-.846zm.81-4.059c.216-.216.729-.225.954 0 .216.216.216.639 0 .954h0l-7.938 7.938c-.315.315-.693.261-.954 0-.216-.216-.216-.639 0-.954h0zm-7.938.108c.846-.954 2.223-.954 3.069 0h0L10.378 7.3l-.81.783-1.692-1.584c-.423-.423-1.062-.423-1.377 0-.315.423-.423 1.062 0 1.377h0l1.656 1.656-.864.837-1.638-1.647c-.954-.846-.954-2.223 0-3.069z",
    stroke: "#3B65EE",
    fill: "#3B65EE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancel);
export default __webpack_public_path__ + "static/assets/icon-cancel.1289059b.svg";
export { ForwardRef as ReactComponent };